import { apiCall } from './gqlClient';

const GETARTICLES_QUERY = `
  query getArticles {
    getArticles
  }`;

export const getArticlesApiCall = async () => apiCall({ query: GETARTICLES_QUERY, variables: {}});

const GETARTICLEBYSLUG_QUERY = `
  query getArticleBySlug($slug: String!) {
    getArticleBySlug(slug: $slug)
  }`;

export const getArticleBySlugApiCall = async ({slug}, ) => apiCall({ query: GETARTICLEBYSLUG_QUERY, variables: {slug}});

const GETAUTHORBYSLUG_QUERY = `
  query getAuthorBySlug($slug: String!) {
    getAuthorBySlug(slug: $slug)
  }`;

export const getAuthorBySlugApiCall = async ({slug}, ) => apiCall({ query: GETAUTHORBYSLUG_QUERY, variables: {slug}});

const GETBLOGCATEGORIES_QUERY = `
  query getBlogCategories {
    getBlogCategories
  }`;

export const getBlogCategoriesApiCall = async () => apiCall({ query: GETBLOGCATEGORIES_QUERY, variables: {}});
